"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROJECT_NAME = void 0;
// REPLACE: replace with project name
exports.PROJECT_NAME = "sps-next";
